module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', [_c('el-collapse-transition', [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isClosed),
      expression: "!isClosed"
    }],
    staticClass: "nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('span', {
    staticClass: "sidebar-mini"
  }, [_vm._v("Mp")]), _vm._v(" "), _c('span', {
    staticClass: "sidebar-normal"
  }, [_vm._v("My Profile")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('span', {
    staticClass: "sidebar-mini"
  }, [_vm._v("Ep")]), _vm._v(" "), _c('span', {
    staticClass: "sidebar-normal"
  }, [_vm._v("Edit Profile")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('span', {
    staticClass: "sidebar-mini"
  }, [_vm._v("S")]), _vm._v(" "), _c('span', {
    staticClass: "sidebar-normal"
  }, [_vm._v("Settings")])])])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/faces/face-2.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("\n           Chet Faker\n           "), _c('b', {
    staticClass: "caret"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f531fbf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/SidebarPlugin/UserMenu.vue
// module id = 516
// module chunks = 55